export const CPFـPivots = (t: any) => [
  {
    Header: t("Farm Code"),
    accessor: "farm_code",
  },
  {
    Header: t("Field Code"),
    accessor: "field_code",
  },
  {
    Header: t("PivotCode"),
    accessor: "item_code",
  },

  {
    Header: t("SupplierName"),
    accessor: "supplier_name",
  },
  {
    Header: t("Installation Date"),
    accessor: "installation_date",
  },
  {
    Header: t("Number_of_Towers"),
    accessor: "number_of_towers",
  },
  {
    Header: t("Last_tower_Speed"),
    accessor: "last_tower_speed",
  },
];
